import { LegendIcon } from "src/design-system/LegendIcon";
import { type IndicatorColor } from "src/design-system/utils/colorPalette";

export type StatusIconVariant = "published" | "draft" | "review" | "archived";

type StatusIconSize = "3xs" | "2xs" | "xs";

type StatusIconProps = {
  variant: StatusIconVariant;
  size?: StatusIconSize;
  dataLoc?: string;
  ref?: React.Ref<HTMLSpanElement>;
};

const VARIANT_TO_COLOR: Record<StatusIconVariant, IndicatorColor> = {
  published: "green-500",
  draft: "yellow-500",
  review: "indigo-400",
  archived: "gray-400",
} as const;

export const StatusIcon: React.FC<StatusIconProps> = ({
  variant,
  size = "3xs",
  dataLoc,
  ref,
}) => (
  <LegendIcon
    ref={ref}
    color={VARIANT_TO_COLOR[variant]}
    dataLoc={dataLoc}
    size={size}
  />
);
